




















import { Component, Prop, Vue } from 'vue-property-decorator'

import { Action } from 'vuex-class'

import { ModalState, Portion, PortionResourcePayload } from '@/models'

import PortionForm from './PortionForm.vue'

@Component({
  components: {
    PortionForm
  }
})
export default class CreatePortionModal extends Vue {
  @Prop({ type: ModalState, required: true })
  readonly modalState!: ModalState

  @Prop({ type: Number, required: true })
  readonly itemGroupId!: number

  @Prop({ type: Number, required: true })
  readonly itemId!: number

  data: PortionResourcePayload | null = null
  isValid = false

  @Action('menu/createPortion')
  createPortion!: (payload: PortionResourcePayload) => Promise<Portion>

  cancel () {
    this.modalState.reset()

    this.data = null

    this.$emit('cancel')
  }

  async submit () {
    if (this.data === null || !this.isValid) {
      return
    }

    try {
      const option = await this.modalState.handle(
        this.createPortion(this.data)
      )

      this.$router.push({
        name: 'PortionDetails',
        params: {
          itemGroupId: this.itemGroupId.toString(),
          itemId: this.itemId.toString(),
          portionId: option.id.toString()
        }
      })
    } catch (e) {
      this.$vs.notify({
        title: 'Não foi possível criar nova porção.',
        color: 'danger',
        fullWidth: true
      })

      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  submitAndClose () {
    this.modalState.isActive = false
    this.submit()
  }
}
